import { ascend, join, pathOr, prop, sortWith } from 'ramda';
import { getApplicationSortOrder } from 'src/features/core/applicationSortOrder';
import { getNamespaceId } from 'src/services/objects/namespaces';
import {
  getDayAfterTommorowDateWithFormat,
  humanizeUTCDateWithoutTimeZone,
} from 'src/utilities/formatDate';
import { mapIndexed } from 'src/utilities/visualFieldsMapper';
import { getPipeLineByNamespaceAndRole } from 'src/features/Advisors/Dashboards/PipeLine/pipeLineConfig';

export const setupNamespacePipelines = () => {
  const tabConfig = pathOr(
    [],
    ['tabs'],
    getPipeLineByNamespaceAndRole(getNamespaceId())
  );

  /* this method is uesd to load default tab for logged in role
   * will return what tabs should be set in the context based on role
   */
  const tabsToDisplay = sortWith([ascend(prop('order_id'))], tabConfig);
  /** The application sort order is static now, so we need to change that to a global setting*/
  const viewPrefs = getApplicationSortOrder([]);

  const currentOrder = pathOr('', ['order'], viewPrefs);

  const currentOrderBy = pathOr('', ['orderBy'], viewPrefs);

  const currentTabs = mapIndexed((tab: any, index: any) => {
    return {
      tabName: tab.title,
      key: tab.key,
      currentOrder: currentOrder,
      currentOrderBy: currentOrderBy,
      isActive: false,
      page: 0,
      tabNumber: index,
      status: '',
      assignee: '',
      name: '',
      search_date: join(' - ', [
        humanizeUTCDateWithoutTimeZone(new Date(0) as any, {
          format: 'YYYY MM DD',
        }),
        getDayAfterTommorowDateWithFormat(),
      ]),
      dateFilterName: '',
      loanPriority: '',
    };
  })(tabsToDisplay);
  return currentTabs;
};
